import type { Store } from './types';

/**
 * GET /api/stores — the real stores (sid > 0) from the cache snapshot.
 *
 * Memoized for the life of the tab: the header's shared store picker mounts
 * on every page, and stores change about once a year, so one request per
 * session is plenty. A failed request is not remembered — the next mount
 * retries. Pages that only needed `overview.stores` for a picker should use
 * this instead of pulling the whole dashboard payload.
 */
let inflight: Promise<Store[]> | null = null;

export function fetchStores(): Promise<Store[]> {
  if (inflight) return inflight;
  const p = (async () => {
    const res = await fetch('/api/stores', { credentials: 'same-origin' });
    if (!res.ok) {
      const text = await res.text().catch(() => '');
      throw new Error(text || `HTTP ${res.status}`);
    }
    return (await res.json()) as Store[];
  })();
  inflight = p;
  p.catch(() => { if (inflight === p) inflight = null; });
  return p;
}

export function resetStoresCacheForTests(): void {
  inflight = null;
}
